import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from './shared';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
        canActivate: [AuthGuard]
    },
    { path: 'login', loadChildren: () => import('./login/login.module').then((m) => m.LoginModule) },
    { path: 'sso-redirect/:token', loadChildren: () => import('./sso-redirect/sso-redirect.module').then((m) => m.SsoRedirectModule) },
    { path: 'forgot-password', loadChildren: () => import('./forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule) },
    { path: 'reset-password', loadChildren: () => import('./reset-password/reset-password.module').then((m) => m.ResetPasswordModule) },
    { path: 'not-found', loadChildren: () => import('./not-found/not-found.module').then((m) => m.NotFoundModule) },
    { path: '**', redirectTo: 'not-found' }
];

@NgModule({
   // imports: [RouterModule.forRoot(routes, {})],
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })], // Added onSameUrlNavigation for reload support for same page
    exports: [RouterModule]
})
export class AppRoutingModule {}
